import { useHistory, useLocation } from 'react-router-dom';
import { Button, Typography } from 'seagull';
import { AnchorLogo } from 'seagull/icons';
import ContactSupportButton from "../../components/ContactSupportButton";
import { redirect, routes } from "../../constants";
import { useEventReporter } from "../../event-reporter/EventReporter";
import { useOnMount } from "../../hooks/useOnMount";
import { selectors } from "../../store/state-selectors";
import { useStore, useStoreActions } from "../../store/store-context";
import { SetLoginFlow } from "../unAuthorizedPages/LoginScreen/LoginScreen.types";
import styles from "./NoAccessPage.module.scss";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const NoAccessPage = () => {
  const {
    setAuthToken
  } = useStoreActions();
  const history = useHistory();
  const location = useLocation();
  const locationState = location.state;
  const existingEmail = useStore(selectors.user.email);
  const recipientEmail = locationState === null || locationState === void 0 ? void 0 : locationState.recipientEmail;
  const returnTo = locationState === null || locationState === void 0 ? void 0 : locationState.returnTo;
  const isVendor = useStore(selectors.user.isVendor);
  const {
    logBI
  } = useStoreActions();
  const {
    sendEventToGtm
  } = useEventReporter();
  const hasAuthToken = useStore(state => state.authToken != null);
  useOnMount(() => {
    if (recipientEmail) {
      logBI(15101);
    } else {
      logBI(15100);
    }
  });
  const descriptionText = recipientEmail && hasAuthToken ? /*#__PURE__*/_jsxs(_Fragment, {
    children: ["This link is meant for ", /*#__PURE__*/_jsx("b", {
      children: recipientEmail
    }), ", but you're logged in as ", /*#__PURE__*/_jsx("b", {
      children: existingEmail
    }), " which does not have the necessary permissions to access this asset.", /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), "To switch users, log out and sign in with the relevant email address. Make sure to save your work first."]
  }) : /*#__PURE__*/_jsxs(_Fragment, {
    children: ["If you believe you should have access or require additional permissions, please contact your account owner or ", /*#__PURE__*/_jsx(ContactSupportButton, {
      hideContactText: true,
      underline: "none",
      variant: "h5"
    }), "."]
  });
  async function logOutUser() {
    sendEventToGtm('logout', {});
    logBI(15103);
    await setAuthToken(null);
    const setLoginFlow = isVendor ? SetLoginFlow.FullLogin : SetLoginFlow.OtpLogin;
    history.replace(redirect.getPathAndSearch({
      returnTo: returnTo
    }), {
      setLoginFlow
    });
  }
  async function backToDashboard() {
    logBI(15102);
    history.replace(routes.home);
  }
  return /*#__PURE__*/_jsxs("div", {
    "data-testid": "notification-no-access-page",
    className: styles.noAccessPageContainer,
    children: [/*#__PURE__*/_jsx(AnchorLogo, {
      theme: "dark",
      height: 44
    }), /*#__PURE__*/_jsx(Typography, {
      variant: "h3",
      weight: "normal",
      testId: "notification-no-access-header",
      children: "You don't have permissions to access this asset"
    }), /*#__PURE__*/_jsx(Typography, {
      variant: "h5",
      testId: "notification-no-access-description",
      className: styles.description,
      children: descriptionText
    }), hasAuthToken && /*#__PURE__*/_jsxs("div", {
      className: styles.buttonContainer,
      children: [/*#__PURE__*/_jsx(Button, {
        skin: recipientEmail ? 'primaryOutline' : 'primary',
        onClick: backToDashboard,
        testId: "notification-no-access-back-to-dashboard-button",
        children: "Back to dashboard"
      }), recipientEmail && /*#__PURE__*/_jsx(Button, {
        skin: "primary",
        onClick: logOutUser,
        testId: "notification-no-access-logout-button",
        children: "Log out"
      })]
    })]
  });
};
export default NoAccessPage;